import React from 'react';
import cx from 'classnames';

interface FormLabelProps {
  required?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
}

const FormLabel = ({ required, disabled, children }: FormLabelProps) => {
  return (
    <label className={cx('form-label', disabled && 'disabled')}>
      {required === true && <span className="tx-danger">* </span>}
      {children} :
    </label>
  );
};

export default FormLabel;
